module.exports = __webpack_public_path__ + "img/LTS_INV.edd8599b.gif";